export default "__VITE_ASSET__Qit5fLfr__"